import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface MenuItem {
  path: string;
  icon: string;
  label: string;
}

interface MenuGroup {
  id: string;
  icon: string;
  label: string;
  items: MenuItem[];
}

const Sidebar: React.FC = () => {
  const location = useLocation();
  const [openDropdowns, setOpenDropdowns] = useState<string[]>([]);

  const menuGroups: MenuGroup[] = [
    {
      id: 'management',
      icon: 'bi-people-fill',
      label: 'Gestão',
      items: [
        { path: '/clients', icon: 'bi-people', label: 'Clientes' },
        { path: '/suppliers', icon: 'bi-building', label: 'Fornecedores' },
        { path: '/bookings', icon: 'bi-calendar-check', label: 'Reservas' },
      ]
    },
    {
      id: 'payments',
      icon: 'bi-credit-card-fill',
      label: 'Pagamentos',
      items: [
        { path: '/payment-templates', icon: 'bi-credit-card', label: 'Templates' },
        { path: '/payment-demo', icon: 'bi-cash-coin', label: 'Demo' },
      ]
    },
    {
      id: 'users',
      icon: 'bi-person-gear',
      label: 'Usuários',
      items: [
        { path: '/users', icon: 'bi-person-gear', label: 'Gerenciar' },
        { path: '/invites', icon: 'bi-envelope', label: 'Convites' },
      ]
    },
    {
      id: 'config',
      icon: 'bi-sliders',
      label: 'Configurações',
      items: [
        { path: '/currencies', icon: 'bi-currency-exchange', label: 'Moedas' },
        { path: '/languages', icon: 'bi-translate', label: 'Idiomas' },
      ]
    },
    {
      id: 'cognito',
      icon: 'bi-shield-lock-fill',
      label: 'Cognito',
      items: [
        { path: '/cognito/user-pools', icon: 'bi-shield-lock', label: 'User Pools' },
        { path: '/cognito/user-pool-origins', icon: 'bi-globe', label: 'Origins' },
      ]
    },
    {
      id: 'system',
      icon: 'bi-gear-fill',
      label: 'Sistema',
      items: [
        { path: '/index-status', icon: 'bi-gear', label: 'Status' },
      ]
    }
  ];

  const toggleDropdown = (groupId: string) => {
    setOpenDropdowns(prev => 
      prev.includes(groupId) 
        ? prev.filter(id => id !== groupId)
        : [...prev, groupId]
    );
  };

  const isGroupActive = (group: MenuGroup) => {
    return group.items.some(item => 
      location.pathname === item.path || 
      (item.path !== '/' && location.pathname.startsWith(item.path))
    );
  };

  return (
    <div className="bg-dark text-white" style={{ width: '250px', minHeight: '100vh' }}>
      <div className="p-3">
        <Link to="/" className="text-decoration-none text-white">
          <img 
            src="/tbi-logo.png" 
            alt="TBI" 
            style={{ height: '40px', width: 'auto' }}
          />
        </Link>
      </div>
      
      <nav className="nav flex-column">
        <Link
          to="/"
          className={`nav-link text-white px-3 py-2 ${
            location.pathname === '/' ? 'bg-primary' : ''
          }`}
        >
          <i className="bi-house me-2"></i>
          Home
        </Link>

        {menuGroups.map((group) => {
          const isOpen = openDropdowns.includes(group.id);
          const isActive = isGroupActive(group);
          
          return (
            <div key={group.id}>
              <button
                className={`nav-link text-white px-3 py-2 w-100 text-start border-0 bg-transparent d-flex justify-content-between align-items-center ${
                  isActive ? 'bg-primary' : ''
                }`}
                onClick={() => toggleDropdown(group.id)}
              >
                <span>
                  <i className={`${group.icon} me-2`}></i>
                  {group.label}
                </span>
                <i className={`bi-chevron-${isOpen ? 'down' : 'right'}`}></i>
              </button>
              
              {isOpen && (
                <div className="ms-3">
                  {group.items.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`nav-link text-white px-3 py-1 ${
                        location.pathname === item.path || 
                        (item.path !== '/' && location.pathname.startsWith(item.path))
                          ? 'bg-secondary' 
                          : ''
                      }`}
                      style={{ fontSize: '0.9rem' }}
                    >
                      <i className={`${item.icon} me-2`}></i>
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;